module.exports = __webpack_public_path__ + "images/fa-verify-certificate-desktop.jpg";